import { USStateObject } from '../../../constants/USstates/constants';
import { getRegionUrl } from '../../../helpers/urls';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { Text } from '../../Text/Text';

interface IProps {
  state: USStateObject;
  isHidden?: boolean;
}

export const StateLink = ({ state, isHidden }: IProps) => {
  const countryId = 'US';
  const countryName = 'United States';
  return (
    <InternalLink
      className={`${isHidden ? 'hidden' : 'flex'} bg-sea-foam rounded-lg p-3`}
      to={getRegionUrl(countryId, state.stateID, countryName, state.stateName)}
    >
      <Text className="mb-0">
        {state.stateName}
        <ArrowRightIcon size={18} className="ml-1" />
      </Text>
    </InternalLink>
  );
};
